/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-file[_ngcontent-%COMP%]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}label.title[_ngcontent-%COMP%]{font-size:14px}.custom-margin[_ngcontent-%COMP%]{margin-bottom:4rem}app-document-card[_ngcontent-%COMP%]{width:100%}.display-flex[_ngcontent-%COMP%]{display:-webkit-box;display:flex}.width-50[_ngcontent-%COMP%]{width:50%}.width-40[_ngcontent-%COMP%]{width:40%}.margin-right-1[_ngcontent-%COMP%]{margin-right:1%}.progress[_ngcontent-%COMP%]{height:auto}"];
export { styles as styles };
